import React, { useEffect } from "react";
import {
  Paper,
  Typography,
  makeStyles,
  Grid,
  Button,
  TextField,
  Drawer,
  Avatar,
} from "@material-ui/core";
import { CommonTable, SelectBox } from "../../../../../../components";
import styles from "../../../../../../components/common/smartForm/styles";
import { generateComponent } from "../../../../../../components/common/smartForm/formsList";
import { withAllContexts } from "../../../../../../HOCs";
import { validationForm } from "../../../../../../utils";
import { useSelector } from "react-redux";
import { actions } from "primary_care_admin_binder";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "40px 30px",
    borderRadius: "0px 0px 8px 8px",
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
    },
    "& .MuiInputBase-input": {
      "& .Mui-disabled": {
        background: "#0000",
      },
    },
  },
  title: {
    fontFamily: "poppinsemibold",
    fontSize: "12px",
  },
  form: {
    border: "1px solid #E0E0E0",
    borderRadius: 8,
  },
  formtitle: {
    fontSize: "12px",
    paddingBottom: 9,
    fontFamily: "pc_regular",
    color: "#6F6F6F",
  },
  formParent: {
    paddingRight: 10,
    paddingTop: 15,
  },
  grid: {
    display: "flex",
    justifyContent: "flex-end",
  },
  addBtn: {
    float: "right",
    fontSize: "14px",
    fontWeight: 600,
  },
  labelGrid: {
    // display: "flex",
    // justifyContent: "center",
    // alignItems: "center",
  },
}));

function ResourceComp(props) {
  const classes1 = useStyles();
  const classes = styles();
  const storeData = useSelector((state) => state?.resourceByAppointmentTypesSlice);
 
  
  const {resourceList, handleFormState, parent_id } = props;
  const [state, setState] = React.useState({
    open: false,
    saveloading: false,
    edit_data: false,
    list: [
      {
        componet_type: "select",
        options: storeData?.res_resource_type_list_doc_qdm?.data ?? [],
        label: "Resource Types",
        state_name: "resType",
        value: "",
        required: true,
      },
      {
        componet_type: "select",
        options: storeData?.res_resource_role_list_doc_qdm?.data ?? [],
        label: "Resource Role",
        state_name: "resRole",
        value: "",
        required: true,
      },
      {
        componet_type: "select",
        options: [] ?? [],
        label: "Resource Department",
        state_name: "Attcode",
        value: "",
        required: true,
      },
      {
        componet_type: "select",
        options: [] ?? [],
        label: "Resource Name",
        state_name: "Attcode",
        value: "",
        required: true,
      },
    ],
    states: {
      Attcode: "",
      label: "",
      Atype: "",
      defaultValue: "",
      _id: "",
    },
  });
  const [resourse, setResourse] = React.useState({
      resourcetype: "",
      resourcerole: "",
      resourcedepartment: [],
      resourcename: [],
    });
  const [resType,setresType]=React.useState({})
  let dispatch = useDispatch();
  useEffect (async() =>{
    await dispatch(actions.RES_RESOURCE_ROLE_LIST_DOC_QDM(resourse?.resourcetype?._id));
  },
[resourse?.resourcetype])

useEffect (async() =>{
  await dispatch(
    actions.RES_RESOURCE_DEPARTMENT_LIST_DOC_QDM({
      resourcetypeId: resourse?.resourcetype?._id,
      resourceroleId: resourse?.resourcerole?._id,
    })
  );
},
[resourse?.resourcerole])
  const handleChangelist = async (key, value) => {
      setResourse({
        ...resourse,
        [key]: value,
      });
      if (key == "resourcetype") {
        setResourse({
          ...resourse,
          [key]: value,
          resourcerole: {},
          resourcedepartment: [],
          resourcename: []
        }) 
        // await dispatch(actions.RES_RESOURCE_ROLE_LIST_DOC_QDM(value?._id));
        return;
      }
  
      if (key == "resourcerole") {
        setResourse({
          ...resourse,
          [key]: value,
          resourcedepartment: [],
          resourcename: []
        }) 
        // await dispatch(
        //   actions.RES_RESOURCE_DEPARTMENT_LIST_DOC_QDM({
        //     resourcetypeId: resourse?.resourcetype?._id,
        //     resourceroleId: value?._id,
        //   })
        // );
        return;
      }
  
      if (key == "resourcedepartment") {
        let resDepId = resourse?.resourcedepartment ?? [];
        if (resourse?.resourcedepartment?.length > 0) {
          resDepId = [];
          const seen = new Set();
          const filteredArr = value.filter((el) => {
            const duplicate = seen.has(el.label);
            seen.add(el.label);
            return !duplicate;
          });
          filteredArr?.map((v,i)=>{
            resDepId.push(v?._id)
          })
          setResourse({
            ...resourse,
            [key]: filteredArr,
            resourcename: []
          })  
        } else {
          resDepId = [];
          value?.map((v,i)=>{
            resDepId.push(v?._id)
          })        
        }
        await dispatch(
          actions.RES_RESOURCE_NAME_LIST_DOC_QDM({
            resourcetypeId: resourse?.resourcetype?._id,
            resourceroleId: resourse?.resourcerole?._id,
            resourcedepartmentId: resDepId ?? [],
          })
        );
        return;
      }
      if (key == "resourcename"){
        if (resourse?.resourcename?.length > 0) {
          const seen = new Set();
          const filteredArr = value.filter((el) => {
            const duplicate = seen.has(el.label);
            seen.add(el.label);
            return !duplicate;
          });
          setResourse({
            ...resourse,
            [key]: filteredArr,
          })
        }
        return;
      }
    };
  const handleDrawerClose = () => {
    setState({
      ...state,
      open: false,
      editIndex: null,
    });
    setResourse({
      resourcetype: "",
      resourcerole: "",
      resourcedepartment: [],
      resourcename: [],
    }
  )
  };
  const saveAgeRange = () => {
    //  let { error, errorState } =validationForm(state.list, state.states);
    // if (!error) {
      let data =resourse;
      let obj = {};
      obj["resourcetype"] = data.resourcetype;
      obj["resourcerole"] = data.resourcerole;
      obj["resourcedepartment"] = data.resourcedepartment;
      obj["resourcename"] = data.resourcename;
      // obj["type"] = data.Atype;
      

      let list = JSON.parse(JSON.stringify(resourceList));

      if (state.editIndex || state.editIndex === 0) {
        list[state.editIndex] = {
          ...list[state.editIndex],
          ...obj,
        };
      } else {
        list.push(obj);
      }
      handleFormState("resourceList", list);

      handleDrawerClose();
    // 
    // else {
    //   props.alert.setSnack("mandatory");
    //    setState({
    //      ...state,
    //      error: errorState,
    //    });
    // }
  };

  const handleEdit = (e, data, index) => {
    // if (data.type === "Number" || data.type === "Text") {
    //   state.list[3] = {
    //     componet_type: "text",
    //     label: "Attribute Default Value",
    //     state_name: "defaultValue",
    //     value: "",
    //     type: data.type === "Number" ? "number" : "text",
    //   };
    // } else {
    //   state.list[3] = {
    //     componet_type: "select",
    //     options: data.Attcode.AttribValidValues,
    //     label: "Attribute Default Value",
    //     state_name: "defaultValue",
    //     value: {},
    //     required: true,
    //   };
    // }
    setState({
      ...state,
      editIndex: index,
      open: true,
    });
    setResourse(
      {
        resourcetype: data?.resourcetype,
        resourcerole: data?.resourcerole,
        resourcedepartment: data?.resourcedepartment,
        resourcename: data?.resourcename,
      }
    )
  };

  const handleDelete = async (e, data, i) => {
    
    let AttriData = JSON.parse(JSON.stringify(resourceList));
    AttriData.splice(i, 1);
    await dispatch(
      actions.DELETE_ATTRIBUTE_DELETE({
        id: data?._id,
      })
    );

    handleFormState("resourceList", AttriData);
    

  };
  const condition = (value, type) => {
    if (type === "DELETE") {
      if (value._id) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
  return (
    <React.Fragment>
      <Paper
        id={`${parent_id}-parent-paper`}
        className={classes1.root} elevation={0}>
        <Grid
          id={`${parent_id}-parent-container`}
          container className={classes1.form} spacing={3}>
          <Grid
            id={`${parent_id}-List-attribute-textField`}
            item xs={12}>
            <Typography
              id={`${parent_id}-List-attribute-typography`}
              className={classes1.title} variant="h6">
              LIST OF RESOURCE
            </Typography>
            <Button
              id={`${parent_id}-Add-New-button`}
              className={classes1.addBtn}
              onClick={() => setState({ ...state, open: true })}
              color="primary"
            >
              + Add New
            </Button>
            <CommonTable
              parent_id={"attributes"}
              Header={[
                "Sequence No",
                "Resource Types",
                "Resource Role",
                "Resource Department",
                "Resource Name",
                "Action",
              ]}
              handleDelete={handleDelete}
              handleEdit={(e, data, index) => handleEdit(e, data, index)}
              dataList={resourceList}
              tableData={[
                { type: ["INCRIMENT"], name: "" },
                { type: ["TEXT"], name: "resourcetype", optionLabel: "label" },
                { type: ["TEXT"], name: "resourcerole",optionLabel: "label"  },
                { type: ["MULTITEXT"], name: "resourcedepartment" },
                { type: ["MULTITEXT"], name: "resourcename"},
                // { type: ["TEXT"], name: "type" },
                // { type: ["TEXT"], name: "defaultValue", optionLabel: "label" },
              { type: ["EDIT", "DELETE"], name: "", align: "left" },
              ]}
              condition={condition}
            />
          </Grid>

          <Drawer
            id={`${parent_id}-Add-New-drawer`}
            className={classes.drawer}
            // variant="persistent"
            anchor="right"
            open={state.open}
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            {
              <div
                id={`${parent_id}-Add-New-drawer`}
              >
                <Avatar
                  id={`${parent_id}-close-avatar`}
                  src="/images/close.svg"
                  className={classes.large}
                  onClick={() => handleDrawerClose()}
                />
                <div>
                  <div
                    id={`${parent_id}-Attributes-div`}
                    className={classes.drawerHead}>
                    <Typography
                      id={`${parent_id}-Attributes-typography`}
                      className={classes.headerMain}>
                      Add Attributes
                    </Typography>
                  </div>

                  <Grid
                    id={`${parent_id}-Button-grid`}
                    container
                    direction="row"
                    style={{ padding: "10px 20px" }}
                  >
                    <Grid
                      id={`${parent_id}-Button-sub-grid`}
                      item xs={12}>
                     <Grid style={{ padding: "10px" }} md={12}>
                      <SelectBox
                      //  parent_id={`${parent_id}_${
                      //    data.state_name ? data.state_name : ""
                      //  }__selectbox`}
                      //  requireStart={data.required}
                        top_title={"Resource Type"}
                        list={ storeData?.res_resource_type_list_doc_qdm?.data ?? []}
                        placeholder={"Search here..."}
                        value={resourse.resourcetype}
                        onchange={(e, value) => handleChangelist("resourcetype", value)}
                      //  error={state?.error?.[data?.state_name] ?? false}
                      //  multi={data.multi ?? false}
                      //  disabled={data.disabled}
                      />
                    </Grid>
                      <Grid style={{ padding: "10px" }} md={12}>
                        <SelectBox
                        //  parent_id={`${parent_id}_${
                        //    data.state_name ? data.state_name : ""
                        //  }__selectbox`}
                        //  requireStart={data.required}
                          top_title={"Resource Role"}
                          list={ storeData?.res_resource_role_list_doc_qdm?.data ?? []}
                          placeholder={"Search here..."}
                          value={ resourse?.resourcerole}
                          onchange={(e, value) => handleChangelist("resourcerole", value)}
                        //  error={state?.error?.[data?.state_name] ?? false}
                        //  multi={data.multi ?? false}
                        //  disabled={data.disabled}
                        />
                      </Grid>
                      <Grid style={{ padding: "10px" }} md={12}>
                        <SelectBox
                        // parent_id={"resourceDefinition-select"}
                        //disabled={Boolean(editData)}
                        multi={true}
                        placeholder={"Search here..."}
                        top_title={" Resource Department"}
                        //disabled={Boolean(editData)}
                        // list={ResourceDepartmentAuto ?? []}
                        list={storeData?.res_resource_department_list_doc_qdm?.data ?? []}
                        value={resourse?.resourcedepartment ?? []}
                        onchange={(e, value) => {
                          handleChangelist("resourcedepartment", value);
                        }}
                        // error={error &&  !resourse?.resourcedepartment?.length > 0}
                      />
                      </Grid>


                      <Grid style={{ padding: "10px" }} md={12}>
                      <SelectBox
                        parent_id={"resourceDefinition-select"}
                        //disabled={Boolean(editData)}
                        multi={true}
                        //disabled={Boolean(editData)}
                        list={storeData?.res_resource_name_list_doc_qdm?.data ?? []}
                        top_title={"Resource Name"}
                        // list={[]}
                        value={resourse?.resourcename ?? []}
        
                        onchange={(e, v) => {
                          handleChangelist("resourcename", v);
                        }}
                        // error={error &&  !resourse?.resourcename?.length > 0}
                      />
                      </Grid>
    
                      <div
                        id={`${parent_id}-Button-div`}
                        className={classes.btnPosition}>
                        <Button
                          id={`${parent_id}-Button`}
                          disabled={props?.loading ?? false}
                          variant={"contained"}
                          color={"primary"}
                          style={{ marginTop: 20 }}
                          size={"small"}
                          contained
                          onClick={() => saveAgeRange()}
                        >
                          {props?.loading ? "Saving..." : "Save"}
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            }
          </Drawer>
        </Grid>
      </Paper>
    </React.Fragment>
  );
}

export default withAllContexts(ResourceComp);
